import React from 'react';
import { Stagger, Item } from './motion';

export const Company = () => (
  <section id="companie" className="section">
    <div className="container">
      <Stagger>
        <Item as="h2" className="hm-h2">
          Poly Tool Design — <span className="accent">software făcut lângă practică.</span>
        </Item>
        <Item as="p" className="hm-sub">
          Suntem o companie românească de software, înființată în 2018 la Constanța. Lucrăm cu
          avocați, practicieni în insolvență și cabinete de contabilitate, iar produsele noastre
          pornesc de la probleme reale ale acestora — nu de la o listă de funcționalități.
        </Item>
        <Item as="p" className="hm-body">
          Primul produs a apărut dintr-o nevoie de birou: prea multe ore pierdute cu corespondența
          unui dosar de insolvență. De acolo au urmat urmărirea dosarelor pe portalul instanțelor
          și, mai târziu, cercetarea în legislație și jurisprudență. Astăzi construim, găzduim și
          întreținem toate cele trei aplicații cu echipa proprie, pe infrastructură pe care o
          controlăm, cu datele clienților procesate în Uniunea Europeană.
        </Item>
      </Stagger>
    </div>
  </section>
);

export default Company;
